import React from 'react';

/**
 * iOS/macOS-style toggle. Pure CSS/Tailwind.
 * Wrapper: h-6 w-11 rounded-full. Off: bg-slate-200 dark:bg-slate-700. On: bg-blue-600.
 * Dot: h-4 w-4 rounded-full bg-white. Off: translate-x-1. On: translate-x-6.
 */
const SettingsToggle = ({ checked, onChange, disabled = false, 'aria-label': ariaLabel }) => (
  <button
    type="button"
    role="switch"
    aria-checked={checked}
    aria-label={ariaLabel}
    disabled={disabled}
    onClick={() => !disabled && onChange(!checked)}
    className={`
      relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent
      transition-colors duration-200 ease-in-out
      focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-white dark:focus:ring-offset-[#080e1a]
      ${checked ? 'bg-blue-600' : 'bg-slate-200 dark:bg-slate-700'}
      ${disabled ? 'opacity-50 cursor-not-allowed' : ''}
    `}
  >
    <span
      className={`
        pointer-events-none inline-block h-4 w-4 transform rounded-full bg-white shadow transition-transform duration-200 ease-in-out
        ${checked ? 'translate-x-6' : 'translate-x-1'}
      `}
    />
  </button>
);

export default SettingsToggle;
